
export default {
    name: 'Breadcrumbs',

    props: {
        breadcrumbs: {
            type: Array,
            default: () => [],
        },
    },
};
